// @flow

module.exports = {
  'api/v3/belajar/packages/detail/new': {
    status: 'success',
    data: {
      serial: '',
      courseSerials: {},
      createdAt: '2022-06-03T00:00:00.814388Z',
      description: '',
      dueOverlapEnd: false,
      dueTime: 0,
      dueType: 'DAY',
      name: '',
      packageGroupId: '10000',
      activeEndDate: '2022-02-11T00:00:00Z',
      activeStartDate: '2022-02-11T00:00:00Z',
      subscribeEndDate: '2022-02-11T00:00:00Z',
      subscribeStartDate: '2022-02-11T00:00:00Z',
      type: 'END',
      curriculums: [],
    },
  },
};
